import { useCallback, useEffect, useRef } from "react";
import { playKenoHit } from './kenoHitSound';

export const useKenoSound = (muted, volume, profile = 'common') => {
  const audio = useRef(null);
  const master = useRef(null);
  const mutedRef = useRef(muted);
  const volumeRef = useRef(volume);
  const profileRef = useRef(profile);
  profileRef.current = profile;
  mutedRef.current = muted;
  volumeRef.current = volume;
  useEffect(() => { if (master.current && audio.current) master.current.gain.setTargetAtTime(muted ? 0 : volume / 100, audio.current.currentTime, .015); }, [muted, volume]);
  useEffect(() => () => { const context = audio.current; audio.current = null; master.current = null; context?.close().catch(() => {}); }, []);
  return useCallback((kind, step = 0) => {
    if (mutedRef.current || volumeRef.current <= 0) return;
    const Audio = window.AudioContext || window.webkitAudioContext;
    if (!Audio) return;
    try {
      const context = audio.current?.state !== 'closed' && audio.current ? audio.current : new Audio();
      if (context !== audio.current) master.current = null;
      audio.current = context;
      if (!master.current) { master.current = context.createGain(); master.current.gain.value = volumeRef.current / 100; master.current.connect(context.destination); }
      if (context.state === "suspended") context.resume().catch(() => {});
      const now = context.currentTime;
      const tone = (frequency, start, duration, volume = .025, type = "sine") => {
        const oscillator = context.createOscillator();
        const gain = context.createGain();
        oscillator.type = type; oscillator.frequency.setValueAtTime(frequency, start);
        gain.gain.setValueAtTime(.0001, start);
        gain.gain.exponentialRampToValueAtTime(volume, start + .008);
        gain.gain.exponentialRampToValueAtTime(.0001, start + duration);
        oscillator.connect(gain); gain.connect(master.current);
        oscillator.start(start); oscillator.stop(start + duration + .02);
        oscillator.onended = () => { oscillator.disconnect(); gain.disconnect(); };
      };
      if (profileRef.current === 'keno' && kind === 'bet') { tone(500, now, .038, .026); tone(310, now + .022, .04, .018); }
      else if (profileRef.current === 'keno' && kind === 'hit') playKenoHit(context, master.current, step);
      else if (kind === "win") [523.25, 659.25, 783.99, 1046.5].forEach((note, i) => tone(note, now + i * .075, .28, .035, "triangle"));
      else if (kind === "bet") { tone(330, now, .12, .035, "triangle"); tone(660, now + .025, .09, .02); }
      else if (kind === "hit") tone(660 + step * 65, now, .16, .035, "triangle");
      else if (kind === "draw") tone(260 + step * 12, now, .05, .008);
      else if (kind === "pick") tone(400 + step * 25, now, .065, .017, "triangle");
      else if (kind === 'slider') tone(580 + step * 3, now, .035, .028, 'triangle');
      else if (kind === "loss") tone(170, now, .15, .012);
      window.dispatchEvent(new CustomEvent("gv-keno-sound", { detail: { kind, volume: volumeRef.current } }));
    } catch { /* Audio is optional; browser restrictions must not interrupt a bet. */ }
  }, []);
};